function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 0C3.13306 0 0 3.13306 0 7C0 10.8669 3.13306 14 7 14C10.8669 14 14 10.8669 14 7C14 3.13306 10.8669 0 7 0ZM10.4323 8.8375C10.5649 8.97016 10.5649 9.18468 10.4323 9.31734L9.31452 10.4323C9.18185 10.5649 8.96734 10.5649 8.83468 10.4323L7 8.58064L5.1625 10.4323C5.02984 10.5649 4.81532 10.5649 4.68266 10.4323L3.56774 9.31452C3.43508 9.18185 3.43508 8.96734 3.56774 8.83468L5.41935 7L3.56774 5.1625C3.43508 5.02984 3.43508 4.81532 3.56774 4.68266L4.68548 3.56492C4.81814 3.43226 5.03266 3.43226 5.16532 3.56492L7 5.41935L8.8375 3.56774C8.97016 3.43508 9.18468 3.43508 9.31734 3.56774L10.4351 4.68548C10.5677 4.81814 10.5677 5.03266 10.4351 5.16532L8.58064 7L10.4323 8.8375Z",
  fill: "#FD6C79"
});

var SvgRedX = function SvgRedX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRedX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redX.1ab231da.svg";
export { ForwardRef as ReactComponent };